import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import style from "../../assets/css/components/Form/Form.module.css";

import { Formik, Form } from "formik";
import Button from "../Button/Button";

import Input from "../Input/Input";
import classNames from "classnames";

import { socket } from "../../config/socket";
import { NumRegisterTeamInitialState, NumRegisterTeamValidationSchema } from "../../utils/updateNumRegister";
const MySwal = withReactContent(Swal);

function FormUpdateNumRegister({teams}) {
  const handleSubmit = async (values) => {
    const { registerPlayer } = values;

    socket.emit("numRegisterPlayer", { registerPlayer, teams }, (res) => {
      MySwal.fire("Actualizado Exitosamente");
    });
  };

  return (
    <Formik
      initialValues={NumRegisterTeamInitialState}
      validationSchema={NumRegisterTeamValidationSchema}
      onSubmit={handleSubmit}
    >
      <Form className={style.form}>
        <Input name="registerPlayer" title="Número de registros" type="number" />
        <div
          className={classNames(style.contButton, style.alignCenter)
          }
        >
          <Button text="Guardar" />
        </div>
      </Form>
    </Formik>
  );
}

export default FormUpdateNumRegister;
